import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
// import { MatTooltipModule } from '@angular/material/tooltip';
import { ChartsModule } from 'ng2-charts';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { PaginatePipe } from 'app/pipes/paginate/paginate.pipe';
// import { NgxPaginationModule } from 'ngx-pagination';
import { MatPaginatorModule } from '@angular/material/paginator';
import { FailedBulkPayTransactionsComponent } from 'app/modules/bulk-pay/failed-bulk-pay-transactions/failed-bulk-pay-transactions.component';
import { PendingBulkPayTransactionsComponent } from 'app/modules/bulk-pay/pending-bulk-pay-transactions/pending-bulk-pay-transactions.component';
import { SuccessfulBulkPayTransactionsComponent } from 'app/modules/bulk-pay/successful-bulk-pay-transactions/successful-bulk-pay-transactions.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TooltipModule } from 'ng2-tooltip-directive';
import { RoundDownPipe } from 'app/pipes/round-down.pipe';
import { FormatAmountDirective } from './directives/format-amount.directive';
import { OtpGateComponent } from './otp-gate/otp-gate.component';
import { NgOtpInputModule } from 'ng-otp-input';

@NgModule({
	declarations: [
		PaginatePipe,
		PendingBulkPayTransactionsComponent,
		FailedBulkPayTransactionsComponent,
		SuccessfulBulkPayTransactionsComponent,
		RoundDownPipe,
		FormatAmountDirective,
		OtpGateComponent

	],
	imports: [
		ReactiveFormsModule,
		FormsModule,
		MatTooltipModule,
		MatInputModule,
		MatSelectModule,
		ChartsModule,
		MatExpansionModule,
		MatPaginatorModule,
		MatIconModule,
		TooltipModule,
		// NgxPaginationModule,
		TranslateModule.forChild(),
		CommonModule,
		NgOtpInputModule,
	],
	exports: [
		CommonModule,
		MatIconModule,
		FormsModule,
		ReactiveFormsModule,
		MatInputModule,
		MatPaginatorModule,
		MatTooltipModule,
		MatSelectModule,
		TooltipModule,
		// NgxPaginationModule,
		ChartsModule,
		MatExpansionModule,
		RoundDownPipe,
		PaginatePipe,
		PendingBulkPayTransactionsComponent,
		FailedBulkPayTransactionsComponent,
		SuccessfulBulkPayTransactionsComponent,
		FormatAmountDirective,
		OtpGateComponent,
	],
	providers: [DatePipe],
})
export class SharedModule {}
